import axios from 'axios';

import i18n from './i18n';

const baseURL = process.env.REACT_APP_URL || 'http://127.0.0.1:8000';

const api = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

// Request interceptor - dodaj token u svaki zahtev
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - rukovanje greškama
api.interceptors.response.use(
    (response) => {
        // Uspešni odgovori prolaze direktno
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            // Unauthorized - ukloni token i redirektuj na login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('permissions');
            localStorage.removeItem('roles');

            // Ukloni Authorization header
            delete api.defaults.headers.common['Authorization'];

            // Redirektuj na login ako nismo već tamo
            if (!window.location.pathname.includes('/#/login')) {
                window.location.href = '/#/login';
            }
        } else if (error.response && error.response.status === 403) {
            // 403 Forbidden - Unauthorized action
            const errorMessage = error.response.data.message || i18n.t('unauthorized_action') || 'This action is unauthorized.';

            // Vrati formatirano odbacivanje za servise
            return Promise.reject({
                errors: [errorMessage],
                status: 403,
                response: error.response
            });
        }

        return Promise.reject(error);
    }
);

// Expose api globally for debugging
window.api = api;

export default api;
